import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Table } from '../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText } from '../../../../helpers/value'
import { selectHeightItemReport } from '../../latestReports/store/slice'
import { NUMBER_ITEM_TABLE, TITLE_TABLE_INTERESTED } from '../constant'
import { getDataTableFromRedux, selectIdsTable } from '../store/slice'
import { PortfolioTd } from './schemaTabe/CustomTd'

export const TableInterested = ({ page }) => {
  const ids = useSelector(selectIdsTable)
  const heightItem = useSelector(selectHeightItemReport)

  const formatIds = useMemo(
    () => ids.slice((page - 1) * NUMBER_ITEM_TABLE, page * NUMBER_ITEM_TABLE),
    [page, ids],
  )

  return (
    <Table
      ids={formatIds}
      isDisplayScroll={false}
      getDataFromRedux={getDataTableFromRedux}
      schema={TITLE_TABLE_INTERESTED.map((item, index) => {
        const result = {
          title: <Translate value={item.label} />,
          colId: item.key,
        }
        if (index === 0) {
          return {
            ...result,
            tdStyle: { width: '40%', padding: '0 12px' },
            renderCustom: (val, { rowId, getStyle }) => {
              return (
                <td style={{ ...getStyle(), height: heightItem }}>
                  <PortfolioTd val={val} id={rowId} />
                </td>
              )
            },
          }
        }
        if (index === 1) {
          return {
            ...result,
            tdStyle: { textAlign: 'right', padding: '0 12px' },
            renderCustom: (val, { rowId, getStyle }) => {
              return <td style={{ ...getStyle() }}>{formatText(val)}</td>
            },
          }
        }
        if (index === 2) {
          return {
            ...result,
            tdStyle: { width: '60%', padding: '0 12px' },
            renderCustom: (val, { rowId, getStyle }) => {
              return (
                <td style={{ ...getStyle() }}>
                  <TextEllipsisStaticLine
                    text={formatText(val)}
                    isI18n={false}
                    lineClamp={1}
                  />
                </td>
              )
            },
          }
        }
        return <></>
      })}
    />
  )
}
